import React from 'react'
import { observer } from 'mobx-react-lite'
import UserStore from '../../stores/UserStore'
import LoadingIndicator from '../atoms/loadingIndicator'
import backendApis from '../../utils/backendApis'

const NudgeBanner = observer(() => {
  const onDismiss = () => {
    UserStore.setNudgeBannerDismissedAt(new Date())
    setTimeout(
      () => {
        UserStore.setNudgeBannerDismissedAt(null)
      },
      1000 * 60 * 5
    ) // 5분 후에 초기화
  }

  const onClickHandler = async () => {
    window.gtag('event', 'clicked_install_CTA', {
      event_category: 'engagement',
      event_label: 'nudge_banner',
    })
    // navigate('/use-app')

    const savedLink = localStorage.getItem('toon_banner_nudge_link')
    if (savedLink) {
      window.open(savedLink, '_blank')
    } else {
      const dynamicLink = await backendApis.createDynamicLink()
      localStorage.setItem('toon_banner_nudge_link', dynamicLink?.data?.link)
      window.open(dynamicLink?.data?.link, '_blank')
    }
  }

  if (!UserStore.isLoaded) {
    return <LoadingIndicator isLoading />
  }

  return (
    <>
      {!UserStore.bottomsheetOpened && !UserStore.nudgeBannerDismissedAt && (
        <div className="flexRow justify-between w-full h-[46vw] px-[6vw] z-40 fixed bottom-0 bg-[#f3f3f3f2]">
          <img src="/images/toon/AppLogo.png" alt="" className="w-[24vw] h-[24vw]" />

          <div className="w-[80vw] flexCol h-full">
            <div className="pb-[4vw]">
              <div className="text-[4.6vw] font-bold">앱을 사용하면 더욱 편하게</div>
              <div className="text-[4.6vw] font-bold">작품을 보실 수 있어요!</div>
            </div>
            <button
              type="button"
              className="w-[52vw] py-[2.6vw] bg-[#F8323E] text-white text-[4.6vw] font-bold rounded-full"
              onClick={onClickHandler}
            >
              앱에서 보기
            </button>
          </div>
          {/* 닫기 버튼 */}
          <button
            type="button"
            className="absolute top-[3vw] right-[3vw] w-[8vw] h-[8vw] z-40"
            onClick={onDismiss}
          >
            <img src="/image/general/basicIcon/close/gray.png" alt="" className="w-full h-auto" />
          </button>
        </div>
      )}
    </>
  )
})

export default NudgeBanner
